module.exports = __webpack_public_path__ + "img/btn-pause.f5184e53.png";